import React from "react";
import { Box } from "@mui/material";
import GridRowAction from "../GridRowAction/GridRowAction";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IsLoggedInUserViewer } from "../../../hoc/withAuthRedirect";
import SwapHorizonOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";

const GridAction = ({ actionsConfig, row, table = null }) => {
  const showPendingIcon = (row.recordResponse?.Status !== undefined && (row.recordResponse.Status === 'PENDING' || row.recordResponse.Status === 'MODIFIED')) ? true : false;
  const showInformationIcon = (IsLoggedInUserViewer() && table !== "userRole") ? true : false;

  return (
    <>
      <Box width={25} />
      {showPendingIcon && (
        actionsConfig.filter(({ action }) => action === "review").map(({ onClick }, index) => (
          <GridRowAction key={index} width={25} height={25} handleSubmit={() => onClick(row)}>
            <SwapHorizonOutlinedIcon fontSize="small" style={{ color: "#EEEEE" }} />
          </GridRowAction>
        ))
      )}

      {showInformationIcon && (
        actionsConfig.filter(({ action }) => action === "edit").map(({ onClick }, index) => (
          <GridRowAction key={index} width={25} height={25} handleSubmit={() => onClick(row)}>
            <VisibilityIcon fontSize="small" style={{ color: "#EEEEE" }} />
          </GridRowAction>))
      )}

      {!showPendingIcon && !showInformationIcon && (
        actionsConfig.filter(({ action }) => action === "edit" || action === "delete").map(({ icon: Icon, onClick, buttonColor }, index) => (
          <GridRowAction key={index} width={25} height={25} handleSubmit={() => onClick(row)}>
            <Icon fontSize="medium" style={{ color: buttonColor }} />
          </GridRowAction>
        ))
      )}
    </>
  );
};

export default GridAction;